import { PageDocumentSlugOnly, PageTypeToPathFunction } from './types/types';
import { urlJoin } from './utils/utils';

// TODO review all these constants
export const AUTHOR_NAME = 'Metabolic Terrain Institute of Health'; // Change to client name
export const COPYRIGHT_DEFAULT_YEAR = 2023;

export const DEFAULT_LANG = 'en';
export const ALL_LANGS = [DEFAULT_LANG] as const;

// WARNING When updating these three constants update in site constants too
// WARNING When updating these three constants update in site create_redirects_file_from_cms too
export const ARTICLES_PREFIX_URL = 'articles';

export const PAGE_DOCUMENT_TYPES = ['page', 'article'] as const;

export const PAGE_TYPE_TO_PATH_FUNCTION = {
  page: (pageDoc: PageDocumentSlugOnly) => urlJoin(pageDoc.slug.current),
  article: (articleDoc: PageDocumentSlugOnly) =>
    urlJoin(ARTICLES_PREFIX_URL, articleDoc.slug.current),
} as const satisfies PageTypeToPathFunction;

// COLORS
// WARNING When updating these constants update in variables.module.scss too
export const COLOR_NEUTRAL_WHITE = '#f9f9f9';
export const COLOR_DARK_BLUE = '#033452';

/**
 *
 * Below here are constants we normally don't need to change or check
 *
 */

export const USE_COOKIES_BANNER = process.env.GATSBY_USE_COOKIES_BANNER;

export const SITE_DOMAIN =
  process.env.NODE_ENV === 'development'
    ? 'localhost:8000'
    : process.env.GATSBY_SITE_DOMAIN || 'null.com';

export const SITE_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : process.env.GATSBY_SITE_BASE_URL || 'https://www.null.com';

export const MAX_OG_DESCRIPTION_LENGTH = 300;

export const GOOGLE_OPTIMIZE_ID = process.env.GATSBY_GOOGLE_OPTIMIZE_ID;
export const SHOULD_RUN_GOOGLE_OPTIMIZE =
  process.env.NODE_ENV === `production` && !!GOOGLE_OPTIMIZE_ID;
